module.exports = __webpack_public_path__ + "static/media/formClose.dba9f898.svg";